import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=09bd2eb6&scoped=true&"
import script from "./photo.vue?vue&type=script&lang=babel&"
export * from "./photo.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bd2eb6",
  null
  
)

export default component.exports